import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { buildFont } from '../commons/utils/buildFont';
// eslint-disable-next-line complexity
export const getFont = (FOUNDATIONS) => {
    return {
        font_heading_1: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_2: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_3: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_4: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_5: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_6: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_7: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_8: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_9: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_10: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_11: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_12: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_13: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_14: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_15: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_16: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_17: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_18: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_19: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_3xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_3xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_3xl || '',
            ],
        }),
        font_heading_20: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_21: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_22: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_2xl || '',
            ],
        }),
        font_heading_23: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_24: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_25: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_26: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_xl || '',
            ],
        }),
        font_heading_27: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_28: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_29: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_1 || '',
                FOUNDATIONS.font_line_height_heading_s_display_1 || '',
            ],
        }),
        font_heading_30: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_31: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_32: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_33: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_4xl || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_4xl || '',
                FOUNDATIONS.font_line_height_heading_s_display_4xl || '',
            ],
        }),
        font_heading_49: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_50: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_100: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_display_2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_display_2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_display_2 || '',
                FOUNDATIONS.font_line_height_heading_s_display_2 || '',
            ],
        }),
        font_heading_200: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h || '',
                FOUNDATIONS.font_line_height_heading_s_h || '',
            ],
        }),
        font_heading_210: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h || '',
                FOUNDATIONS.font_line_height_heading_s_h || '',
            ],
        }),
        font_heading_225: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h || '',
                FOUNDATIONS.font_line_height_heading_s_h || '',
            ],
        }),
        font_heading_230: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h || '',
                FOUNDATIONS.font_line_height_heading_xllm_h || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h || '',
                FOUNDATIONS.font_line_height_heading_s_h || '',
            ],
        }),
        font_heading_250: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h1 || '',
                FOUNDATIONS.font_line_height_heading_s_h1 || '',
            ],
        }),
        font_heading_260: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h1 || '',
                FOUNDATIONS.font_line_height_heading_s_h1 || '',
            ],
        }),
        font_heading_300: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h1 || '',
                FOUNDATIONS.font_line_height_heading_s_h1 || '',
            ],
        }),
        font_heading_310: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h1 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h1 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h1 || '',
                FOUNDATIONS.font_line_height_heading_s_h1 || '',
            ],
        }),
        font_heading_400: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h2 || '',
                FOUNDATIONS.font_line_height_heading_s_h2 || '',
            ],
        }),
        font_heading_410: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h2 || '',
                FOUNDATIONS.font_line_height_heading_s_h2 || '',
            ],
        }),
        font_heading_450: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h2 || '',
                FOUNDATIONS.font_line_height_heading_s_h2 || '',
            ],
        }),
        font_heading_460: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_xllm_h2 || '',
                FOUNDATIONS.font_line_height_heading_xllm_h2 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_s_h2 || '',
                FOUNDATIONS.font_line_height_heading_s_h2 || '',
            ],
        }),
        font_paragraph_50: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        font_paragraph_60: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        font_paragraph_100: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        font_paragraph_110: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        link_font_paragraph_50: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        link_font_paragraph_60: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        link_font_paragraph_100: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        link_font_paragraph_110: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_large || '',
                FOUNDATIONS.font_line_height_paragraph_large || '',
            ],
        }),
        font_paragraph_200: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        font_paragraph_210: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        font_paragraph_250: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        font_paragraph_260: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        link_font_paragraph_200: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        link_font_paragraph_210: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        link_font_paragraph_250: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        link_font_paragraph_260: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_medium || '',
                FOUNDATIONS.font_line_height_paragraph_medium || '',
            ],
        }),
        font_paragraph_350: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        font_paragraph_360: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        font_paragraph_400: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        font_paragraph_410: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        link_font_paragraph_350: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        link_font_paragraph_360: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        link_font_paragraph_400: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        link_font_paragraph_410: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_paragraph_small || '',
                FOUNDATIONS.font_line_height_paragraph_small || '',
            ],
        }),
        font_paragraph_500: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
        }),
        font_paragraph_550: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
        }),
        link_font_paragraph_500: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
        }),
        link_font_paragraph_550: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_medium || '',
                FOUNDATIONS.font_line_height_caption_medium || '',
            ],
        }),
        font_paragraph_650: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
        }),
        font_paragraph_700: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_caption_small || '',
                FOUNDATIONS.font_line_height_caption_small || '',
            ],
        }),
        // DS Only
        font_title_50: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_title_ds || '',
                FOUNDATIONS.font_line_height_heading_title_ds || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_title_ds || '',
                FOUNDATIONS.font_line_height_heading_title_ds || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_title_ds || '',
                FOUNDATIONS.font_line_height_heading_title_ds || '',
            ],
        }),
        font_title_100: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_size_heading_title_ds_50 || '',
                FOUNDATIONS.font_line_height_heading_title_ds_50 || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_size_heading_title_ds_50 || '',
                FOUNDATIONS.font_line_height_heading_title_ds_50 || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_size_heading_title_ds_50 || '',
                FOUNDATIONS.font_line_height_heading_title_ds_50 || '',
            ],
        }),
        font_avatarl: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_l || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_l || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_l || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_l || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_l || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_l || '',
            ],
        }),
        font_avatarms: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_ms || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_ms || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_ms || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_ms || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_ms || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_ms || '',
            ],
        }),
        font_avatarxs: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xs || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xs || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xs || '',
            ],
        }),
        font_avatarxxs: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xxs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xxs || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xxs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xxs || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_exception_size_paragraph_avatar_xxs || '',
                FOUNDATIONS.font_exception_line_height_paragraph_avatar_xxs || '',
            ],
        }),
        font_inputcurrency: buildFont({
            [DeviceBreakpointsType.DESKTOP]: [
                FOUNDATIONS.font_exception_size_paragraph_input_currency || '',
                FOUNDATIONS.font_exception_line_height_paragraph_input_currency || '',
            ],
            [DeviceBreakpointsType.TABLET]: [
                FOUNDATIONS.font_exception_size_paragraph_input_currency || '',
                FOUNDATIONS.font_exception_line_height_paragraph_input_currency || '',
            ],
            [DeviceBreakpointsType.MOBILE]: [
                FOUNDATIONS.font_exception_size_paragraph_input_currency || '',
                FOUNDATIONS.font_exception_line_height_paragraph_input_currency || '',
            ],
        }),
    };
};
//# sourceMappingURL=font.js.map